import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import { RegexHelper, isSameUser } from "src/common";
import { FormField } from "src/components";
import _ from "lodash";
import * as yup from "yup";

type AllProps = {
  is_edit?: boolean;
  group_alias: string;
  aliases: string[];
  setGroupAlias: Dispatch<SetStateAction<string>>;
  setInvalidAlias: Dispatch<SetStateAction<boolean>>;
};

// Description: Component for entering or editing the user group email address in the Create Email Group Modal.
function AliasFormComponent(props: AllProps) {
  const { is_edit, group_alias, setGroupAlias, setInvalidAlias, aliases } = props;
  const [existing_alias, setExistingAlias] = useState<boolean>(false);
  const [invalid_email, setInvalidEmail] = useState<boolean>(false);
  const schema = yup.object().shape({
    alias: yup.string()
      .test("group-email", "The user group email address is required.", (value: string | undefined) => {
        !value && setGroupAlias("");
        return !!value;
      })
      .test("group-email", "The user group email is already taken.", (value: string | undefined) => {
        if (value) {
          const not_existing = aliases.filter((address: string) => isSameUser(address, value)).length === 0;
          setExistingAlias(!not_existing);
          return not_existing;
        }
        return !!value;
      })
      .test("group-email", "The user group email address is not in the correct format, e.g. john@gmail.com, outlook.com", (value) => {
        if (value) {
          const test = RegexHelper.testEmailAddress(value);
          setInvalidEmail(!test);
          return test;
        }
        return !!value;
      })
  });

  useEffect(() => {
    setInvalidAlias(existing_alias || invalid_email);
  }, [existing_alias, invalid_email]);

  // Description: Handle form submit
  function handleSubmit(values: { alias: string }) {
    const group_alias = values.alias;
    setGroupAlias(group_alias);
  }

  return <>
    {is_edit ?
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        onBlur={handleSubmit}
        enableReinitialize={true}
        initialValues={{
          alias: group_alias
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form noValidate className="mb-4" onSubmit={handleSubmit}>
            <FormField
              id="group_name"
              autoComplete="off"
              autoFocus={true}
              className="mb-4"
              label="User Group Email Address"
              type="text"
              errors={errors.alias}
              touched={touched.alias}
              handleBlur={handleSubmit}
              handleChange={handleChange("alias")}
              value={values.alias}
              required={true} />
          </Form>
        )}
      </Formik>
      : <>{!_.isEmpty(group_alias) && <span>User Group Email Address:<b className="ms-1">{group_alias}</b></span>}</>}
  </>;
}

export default React.memo(AliasFormComponent);
